import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
  DestroyRef,
} from '@angular/core';

// interfaces
import {
  FilterType,
  AppliedFilterType,
} from '@app/core/interfaces/filter.interface';

// services
import { FiltersService } from '@app/core/services/filters/filters.service';

// rxjs
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Ag1PillComponent } from './ag1-pill/ag1-pill.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'ag1-pill-group',
  templateUrl: './ag1-pill-group.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Ag1PillComponent],
})
export class Ag1PillGroupComponent implements OnInit {
  private _destroyRef = inject(DestroyRef);
  private filtersService = inject(FiltersService);
  filters: FilterType[] = [];
  appliedFilters: AppliedFilterType;

  constructor() {}

  ngOnInit(): void {
    this.filters$().pipe(takeUntilDestroyed(this._destroyRef)).subscribe();
    this.appliedFilters$()
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe();
  }

  appliedFilters$(): Observable<AppliedFilterType> {
    return this.filtersService.getAppliedFilters$().pipe(
      takeUntilDestroyed(this._destroyRef),
      tap((appliedFilters: AppliedFilterType) => {
        this.appliedFilters = appliedFilters;
      }),
    );
  }

  filters$(): Observable<FilterType[]> {
    return this.filtersService.getFilters$().pipe(
      takeUntilDestroyed(this._destroyRef),
      tap((filters: FilterType[]) => {
        this.filters = filters;
      }),
    );
  }
}
